import * as yup from 'yup'
export const groupSchema = yup.object().shape({
  name: yup.string().required('nameRequired'),
  colorCode: yup.string().optional().nullable().default(''),
  description: yup.string().optional().nullable(),
  contactsId: yup.array().of(yup.string())
})
